<template>
  <v-layout column >
    <div id="splash-container" >
      <img :src="landingPhoto">
      <div id="splash-band" ></div>
      <div id="splash-text">
        <h1>Life Sciences Internship Fellowships</h1>
      </div>
    </div>
    <div>
      Life Sciences Internship Fellowships (LSIF) are prestigious summer internships at facilities with whom the College 
      has formal agreements at basic or applied research centers. These experiences are funded up to $8,000 - $10,000 per
       student to intern onsite for 30-40 hours per week over 12-16 weeks (spring-summer terms). Students may apply to one or more separate application pathways according to their interest or experience:  
    </div>
    <ul style="padding-top: 8px">
      <li>Basic or Applied Research (College of Life Sciences, contact lsinternships@byu.edu)</li>
      <li>Pre-medical Research (BYU Summer Premed Research Internship, contact tyler_pedersen@byu.edu)</li>
      <li>Cancer Research (BYU Simmons Center for Cancer Research, contract sccr@chem.byu.edu)</li>
    </ul>
    <img :src="fundImg"> 
    <h2 style="padding: 16px 0">Eligibility Expectations</h2>
    <div>
      The Life Sciences Internship Fellowship is intended to be a full-time job working 30-40 hours per week.
    </div>
    <div>Aapplicants must</div>
    <ul>
      <li>Applications are due January 15th</li>
      <li>Be a Life Sciences undergraduate major.</li>
      <li>Be available for 12-15 weeks for 30-40 hours per week.</li>
      <li>Be a student who will graduate after August 2024.</li>
      <li>Maintain a cumulative GPA of 3.0 or higher.</li>
      <li>Enroll in at least 1.0 credit hour of internship (399R or 496R) through their department.</li>
      <li>Be willing to submit regular updates to the dean's office (deansec@byu.edu) and a thank you letter to the donors.</li>
      <li>Discuss prior research experience though it is helpful but not necessary.</li>
      <li>If you have any questions please email lsinternships@byu.edu</li>
    </ul>
    <v-layout style="padding-top: 16px">
      <v-btn color="primary" @click="goTo('/apply')" >Apply Now</v-btn>
      <div style="width: 16px" ></div>
      <v-btn color="accent" @click="goTo('/available')" >Available Internships</v-btn>
    </v-layout>
  </v-layout>
</template>

<script>

import photo from '../assets/lab.jpg'
import fundImage from '../assets/FundingImg.png'

export default {
    name: 'Home',
    data() {
        return {

        }
    },
    computed: {
      landingPhoto() {
        return photo
      },
      fundImg() {
        return fundImage
      }
    },
    methods: {
      goTo(url) {
        this.$router.push(url)
      }
    }
}
</script>

<style>
  #splash-container {
    width: 100%;
    left: 0px;
    position: relative;
    top: -16px;
  }

  #splash-container img {
    width: 100%;
  }

  #splash-container #splash-text {
    position: absolute;
    bottom: 64px;
    color: black;
    width: 100%;
    text-align: center;
    padding: 16px;
    z-index: 10;
  }

  #splash-container #splash-band {
    background-color: white;
    height: 72px;
    width: 100%;
    position: absolute;
    z-index: 5;
    bottom: 68px;
    opacity: .5;
  }
</style>